import React from 'react';
import Alert from '@mui/material/Alert';
import InfoIcon from '@mui/icons-material/Info';

export default function PersonalAllowanceAlert({ effectivePersonalAllowance, salary, pensionDeduction, config }) {
  // Convert to numbers to ensure correct comparisons
  const effective = Number(effectivePersonalAllowance);
  const defaultAllowance = Number(config.PERSONAL_ALLOWANCE);
  const difference = Number(salary - config.PERSONAL_ALLOWANCE_THRESHOLD - pensionDeduction);

  // Only show the alert if the effective allowance is reduced
  if (effective >= defaultAllowance) {
    return null;
  }
// TODO - this isn't using the adjusted (after pension) figures
  return (
  <Alert icon={<InfoIcon fontSize="inherit" />} severity="info">
    Your adjusted net income is over the personal allowance threshold of <strong>£{config.PERSONAL_ALLOWANCE_THRESHOLD.toLocaleString()}</strong> by <strong>£{difference.toLocaleString()}</strong>.
    Your personal allowance has been reduced by <strong>£{(defaultAllowance - effective).toLocaleString()}</strong>—now <strong>£{effective.toLocaleString()}</strong> instead of the default <strong>£{defaultAllowance.toLocaleString()}</strong>.
    (Every £2 earned over £{config.PERSONAL_ALLOWANCE_THRESHOLD.toLocaleString()} reduces your allowance by £1.)
  </Alert>
  );
}
